// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PControlOutlinedSvg from "@fishx/icons-svg/es/asn/PControlOutlined";
import FishxIcon from '../components/FishxIcon';

var PControlOutlined = function PControlOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PControlOutlinedSvg
  }));
};

PControlOutlined.displayName = 'PControlOutlined';
export default React.forwardRef(PControlOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PControlOutlined.js
// module id = 3312
// module chunks = 0